webpackJsonp([18],{

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(237)

var Component = __webpack_require__(12)(
  /* script */
  null,
  /* template */
  __webpack_require__(259),
  /* scopeId */
  "data-v-428575e3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(241)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(263),
  /* scopeId */
  "data-v-d6d81f38",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(236)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(162),
  /* template */
  __webpack_require__(258),
  /* scopeId */
  "data-v-1bcf02b4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(239)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(163),
  /* template */
  __webpack_require__(261),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(240)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(262),
  /* scopeId */
  "data-v-6f956ed6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(235)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(165),
  /* template */
  __webpack_require__(257),
  /* scopeId */
  "data-v-1017dda4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Login = __webpack_require__(108);

var _Login2 = _interopRequireDefault(_Login);

var _ = __webpack_require__(106);

var _2 = _interopRequireDefault(_);

var _Home = __webpack_require__(107);

var _Home2 = _interopRequireDefault(_Home);

var _index = __webpack_require__(109);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = [{
    path: '/login',
    component: _Login2.default,
    name: '',
    hidden: true
}, {
    path: '/404',
    component: _2.default,
    name: '',
    hidden: true
}, {
    path: '/',
    component: _Home2.default,
    name: '个人资料',
    iconCls: 'fa fa-id-card-o',
    leaf: true,
    hidden: true,
    children: [{ path: '/personalData', component: _index2.default, name: '资料编辑' }]
}, {
    path: '*',
    hidden: true,
    redirect: { path: '/404' }
}];

exports.default = routes;

/***/ }),

/***/ 113:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 114:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 115:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 116:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(238)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(160),
  /* template */
  __webpack_require__(260),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	name: 'app',
	components: {}
};

/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(42);

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__(177);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _baseUrl = __webpack_require__(70);

var _baseUrl2 = _interopRequireDefault(_baseUrl);

var _vuex = __webpack_require__(37);

var _index = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      sysName: "龙杰一拍通",
      collapsed: false,
      sysUserName: "",
      adminRoleId: "",
      sysUserAvatar: "",
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      maxtime: 600,
      minutes: null,
      seconds: null,
      menuList: [],
      nodes: this.$router.options.routes
    };
  },
  created: function created() {
    this.CountDown();
    var isLoadNodes = sessionStorage.getItem('isLoadNodes');
    var data = JSON.parse(window.sessionStorage.getItem('menu'));
    if (!isLoadNodes) {
      var _nodes;

      this.nodes.splice(4, this.nodes.length - 4);
      var newData = (0, _index.processRoutingStructure)(data);
      (_nodes = this.nodes).push.apply(_nodes, (0, _toConsumableArray3.default)(newData));
      console.log(this.nodes);
      sessionStorage.setItem('isLoadNodes', 'true');
    }
    console.log(this.$router);
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    users: function users(state) {
      return state.user;
    }
  })),
  methods: {
    logout: function logout() {
      var _this = this;
      this.$confirm("确认退出吗?", "提示", {}).then(function () {
        sessionStorage.removeItem("user");
        _this.$router.push("/login");
      }).catch(function () {});
    },

    collapse: function collapse() {
      this.collapsed = !this.collapsed;
    },
    CountDown: function CountDown() {
      var _this2 = this;

      var interval = setInterval(function () {
        var obj = null;
        if (_this2.maxtime >= 0) {
          _this2.minutes = Math.floor(_this2.maxtime / 60);
          _this2.seconds = Math.floor(_this2.maxtime % 60);
          _this2.maxtime--;
        } else {
          clearInterval(interval);
          window.location.reload();
        }
      }, 1000);
    },
    showMenu: function showMenu(i, status) {
      this.$refs.menuCollapsed.getElementsByClassName("submenu-hook-" + i)[0].style.display = status ? "block" : "none";
    },
    settings: function settings() {
      this.$router.push("/personalData");
    }
  },
  mounted: function mounted() {
    var user = sessionStorage.getItem("user");
    if (user) {
      user = JSON.parse(user);
      this.sysUserName = user.username || "";
      this.adminRoleId = user.role_name;
      this.sysUserAvatar = _baseUrl2.default + "/" + user.avatar || "";
    }
  }
};

/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(41);

var _stringify2 = _interopRequireDefault(_stringify);

var _api = __webpack_require__(38);

var _index = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      logining: false,
      ruleForm2: {
        account: 'admin',
        checkPass: 'admin888',
        verifyCode: ''
      },
      htmlscode: '',
      rules2: {
        account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        checkPass: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },

      routers: []
    };
  },
  created: function created() {
    this.getVcode();
  },

  methods: {
    getVcode: function getVcode() {
      var _this2 = this;

      (0, _api.getCode)().then(function (res) {
        _this2.htmlscode = res;
      });
    },
    handleSubmit2: function handleSubmit2(ev) {
      var _this3 = this;

      var _this = this;
      this.$refs.ruleForm2.validate(function (valid) {
        if (valid) {
          _this3.logining = true;
          var loginParams = {
            username: _this3.ruleForm2.account,
            password: _this3.ruleForm2.checkPass,
            verify: _this3.ruleForm2.verifyCode
          };
          (0, _api.requestLogin)(loginParams).then(function (data) {
            _this3.logining = false;
            if (data.errno == 0) {
              var user = data.data.userInfo;
              var token = data.data.token;
              _this3.$store.commit('LOCIN_IN', token);
              _this3.$store.commit('MODIFY_USER', user);
              console.log(data.data.userInfo.menu);
              sessionStorage.setItem('user', (0, _stringify2.default)(user));
              var routeList = (0, _index.processRoutingStructure)(data.data.userInfo.menu);
              window.sessionStorage.setItem('menu', (0, _stringify2.default)(data.data.userInfo.menu));
              _this3.$router.addRoutes(routeList);
              _this3.$router.push({ path: '/charts/echarts' });
            } else {
              _this3.$message.error(data.errmsg);
            }
          });
        } else {
          return false;
        }
      });
    },
    switchVerificationCode: function switchVerificationCode() {
      this.getVcode();
    }
  }
};

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _management = __webpack_require__(110);

var _management2 = _interopRequireDefault(_management);

var _password = __webpack_require__(111);

var _password2 = _interopRequireDefault(_password);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    management: _management2.default,
    password: _password2.default
  }
};

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(41);

var _stringify2 = _interopRequireDefault(_stringify);

var _api = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      value: {
        user_name: ""
      },
      user: {},
      imgUrl: "",
      deafult: "https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1562929485581&di=d8f57f0c310c8eb6099e3c52a8a33986&imgtype=0&src=http%3A%2F%2Fb-ssl.duitang.com%2Fuploads%2Fitem%2F201704%2F27%2F20170427155254_Kctx8.thumb.700_0.jpeg"
    };
  },
  created: function created() {},

  methods: {
    uploadPicture: function uploadPicture(e) {
      var _this = this;

      var fileName = e.target.files[0].name;
      console.log(fileName);
      var regex = /(.jpg|.png|.bmp)$/;
      if (regex.test(fileName.toLowerCase())) {
        var formData = new FormData();
        var parms = e.target.files[0];
        console.log(parms);
        formData.append("uploadFile", parms);
        (0, _api.setadminpic)(formData).then(function (res) {
          if (res.errno == 0) {
            _this.imgUrl = res.data.fileUrl;
            var url = _this.imgUrl.lastIndexOf("/");
            var relUrl = _this.imgUrl.substring(url + 1);
            var user = {
              admin_role_id: _this.user.admin_role_id,
              avatar: relUrl,
              id: _this.user.id,
              username: _this.user.username
            };
            sessionStorage.setItem('user', (0, _stringify2.default)(user));
            _this.$message({
              message: '头像上传成功',
              type: "success"
            });
            setTimeout(function () {
              window.location.reload();
            }, 1000);
          }
        });
      } else {
        this.$message.error("请注意图片格式和上传图片数量");
        return;
      }
    },
    submitForm: function submitForm() {}
  },
  mounted: function mounted() {
    var user = sessionStorage.getItem("user");
    user = JSON.parse(user);
    this.user = user;
    console.log(user);
    this.value.user_name = user.username;
  }
};

/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(38);

exports.default = {
  data: function data() {
    return {
      value: {
        user_name: "",
        passwors: "",
        newPasswors: ""
      }
    };
  },

  methods: {
    submitForm: function submitForm() {
      this.passwordAuthentication();
    },
    passwordAuthentication: function passwordAuthentication() {
      var _this = this;

      if (this.value.user_name == "") {
        this.$message.error("原密码不能为空");
      } else if (this.value.passwors == "") {
        this.$message.error("新密码不能为空");
      } else if (this.value.newPasswors == "") {
        this.$message.error("确定密码不能为空");
      } else if (this.value.passwors !== this.value.newPasswors) {
        this.$message.error("两次密码不一样");
      } else {
        var pam = {
          oPassword: this.value.user_name,
          newPassword1: this.value.passwors,
          newPassword2: this.value.newPasswors
        };
        (0, _api.updatapwd)(pam).then(function (res) {
          if (res.errno == 0) {
            _this.$message(res.data.msg);
          } else {
            _this.$message.error(res.errmsg);
          }
        });
      }
    }
  }
};

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(3);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(118);

var _App2 = _interopRequireDefault(_App);

var _elementUi = __webpack_require__(69);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(113);

__webpack_require__(115);

var _httpConfig = __webpack_require__(67);

var _httpConfig2 = _interopRequireDefault(_httpConfig);

var _vueRouter = __webpack_require__(119);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _index = __webpack_require__(68);

var _index2 = _interopRequireDefault(_index);

var _vuex = __webpack_require__(37);

var _vuex2 = _interopRequireDefault(_vuex);

__webpack_require__(116);

var _routes = __webpack_require__(112);

var _routes2 = _interopRequireDefault(_routes);

__webpack_require__(114);

__webpack_require__(117);

var _index3 = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.prototype.$http = _httpConfig2.default;
_vue2.default.use(_elementUi2.default);
_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vuex2.default);

_vue2.default.config.productionTip = false;


var router = new _vueRouter2.default({
  routes: _routes2.default
});
var data = JSON.parse(window.sessionStorage.getItem('menu'));
if (data) {
  var datas = (0, _index3.processRoutingStructure)(data);
  console.log(datas);
  router.addRoutes(datas);
  sessionStorage.removeItem('isLoadNodes');
}
router.beforeEach(function (to, from, next) {
  var data = JSON.parse(window.sessionStorage.getItem('menu'));
  if (data && to.path == '/login') {
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('menu');
    sessionStorage.removeItem('isLoadNodes');
  }
  var user = JSON.parse(sessionStorage.getItem('user'));
  if (!user && to.path != '/login') {
    next({ path: '/login' });
  } else {
    next();
  }
});

new _vue2.default({
  router: router,
  store: _index2.default,

  render: function render(h) {
    return h(_App2.default);
  }
}).$mount('#app');

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {};

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {};

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _util = __webpack_require__(256);

exports.default = {
    LOCIN_IN: function LOCIN_IN(state, token) {
        state.UserToken = token;
    },
    MODIFY_USER: function MODIFY_USER(state, param) {
        console.log(param);
        state.user = param;
    }
};

/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    get UserToken() {
        return localStorage.getItem('token');
    },
    set UserToken(value) {
        localStorage.setItem('token', value);
    },
    user: {}
};

/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (name) {
  return function () {
    return __webpack_require__(265)("./views" + name + ".vue");
  };
};

/***/ }),

/***/ 235:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 236:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 237:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 238:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 239:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 240:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 241:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.processRoutingStructure = exports.generateTreeStructure = exports.generateId = exports.getNowMonthDate = exports.page = exports.OrderJudgmentCondition = exports.GMTToStr = exports.turnTimestamp = exports.fieldTransformation = exports.currentTime = exports.formatTime = exports.formatDay = exports.formatDate = undefined;

var _stringify = __webpack_require__(41);

var _stringify2 = _interopRequireDefault(_stringify);

var _menuList = __webpack_require__(171);

var _menuList2 = _interopRequireDefault(_menuList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formatDate = exports.formatDate = function formatDate(params) {
    var date = new Date(parseInt(params) * 1000);
    var Y = date.getFullYear() + "-";
    var M = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) + "-" : date.getMonth() + 1 + "-";
    var D = date.getDate() < 10 ? "0" + date.getDate() + " " : date.getDate() + " ";
    var h = date.getHours() < 10 ? "0" + date.getHours() + ":" : date.getHours() + ":";
    var m = date.getMinutes() < 10 ? "0" + date.getMinutes() + ":" : date.getMinutes() + ":";
    var s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    return Y + M + D + h + m + s;
};

var formatDay = exports.formatDay = function formatDay(params) {
    var date = new Date(parseInt(params) * 1000);
    var Y = date.getFullYear() + "-";
    var M = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) + "-" : date.getMonth() + 1 + "-";
    var D = date.getDate() < 10 ? "0" + date.getDate() + " " : date.getDate() + " ";
    return Y + M + D;
};

var formatTime = exports.formatTime = function formatTime(params) {
    var date = new Date(parseInt(params));
    var Y = date.getFullYear() + "-";
    var M = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) + "-" : date.getMonth() + 1 + "-";
    var D = date.getDate() < 10 ? "0" + date.getDate() + " " : date.getDate() + " ";
    var h = date.getHours() < 10 ? "0" + date.getHours() + ":" : date.getHours() + ":";
    var m = date.getMinutes() < 10 ? "0" + date.getMinutes() + ":" : date.getMinutes() + ":";
    var s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    return Y + M + D + h + m + s;
};

var currentTime = exports.currentTime = function currentTime() {
    var date = new Date();
    var Y = date.getFullYear() + "-";
    var M = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) + "-" : date.getMonth() + 1 + "-";
    var D = date.getDate() < 10 ? "0" + date.getDate() + " " : date.getDate() + " ";
    var h = date.getHours() < 10 ? "0" + date.getHours() + ":" : date.getHours() + ":";
    var m = date.getMinutes() < 10 ? "0" + date.getMinutes() + ":" : date.getMinutes() + ":";
    var s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    return Y + M + D;
};

var fieldTransformation = exports.fieldTransformation = function fieldTransformation(val) {
    if (val == "username") {
        return "用户名";
    } else if (val == "gender") {
        return "性别";
    } else if (val == "id") {
        return "id";
    } else if (val == "birthday") {
        return "生日";
    } else if (val == "register_time") {
        return "注册时间";
    } else if (val == "last_login_time") {
        return "最后登录的时间";
    } else if (val == "last_login_ip") {
        return "ip";
    } else if (val == "user_level_id") {
        return "用户级别id";
    } else if (val == "nickname") {
        return "昵称";
    } else if (val == "readername") {
        return "设备号";
    } else if (val == "register_ip") {
        return "注册知识产权";
    } else if (val == "avatar") {
        return "图片";
    } else if (val == "weixin_openid") {
        return "微信ID";
    } else if (val == "mobile") {
        return "电话";
    }
};

var turnTimestamp = exports.turnTimestamp = function turnTimestamp(time) {
    var thisTime = time;
    thisTime = thisTime.replace(/-/g, '/');
    var time = new Date(thisTime);
    var times = time.getTime() / 1000;
    return times;
};

var GMTToStr = exports.GMTToStr = function GMTToStr(time) {
    var date = new Date(time);
    var Str = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
    return Str;
};

var OrderJudgmentCondition = exports.OrderJudgmentCondition = function OrderJudgmentCondition(data) {
    var newData = [];
    data.map(function (item) {
        if (item.pay_status == 0) {
            newData.push(item);
        }
    });
    console.log(newData);
    return newData;
};

var page = exports.page = function page(pageSize, total, pageNum) {
    var pageSize = pageSize;
    var pageTotal = Math.ceil(total / pageSize);
    var pageNum = pageNum - 1 || 0;
    function cutArry() {
        var arr = [];
        for (var i = 0; i < pageTotal; i++) {
            var len = pageSize;
            var strat = i * len;
            var end = strat + len;
            arr.push(data.slice(strat, end));
        }
        return arr;
    }
};

var getNowMonthDate = exports.getNowMonthDate = function getNowMonthDate(mon) {
    var date = new Date();
    var year = date.getFullYear() + "";
    var month = date.getMonth() < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;

    var lastMonth = date.getMonth() < 10 ? "0" + date.getMonth() : date.getMonth();
    var last = lastMonth == 0 ? 12 : lastMonth;
    var lastyear = date.getMonth() == 0 ? year - 1 : year;

    var begin = year + "-" + month + "-01";

    var lastbegin = lastyear + "-" + last + "-01";

    var DateOfCurrentMonth = new Date(lastyear, last, 0);
    var lastend = lastyear + "-" + last + "-" + DateOfCurrentMonth.getDate();

    var lastDateOfCurrentMonth = new Date(year, month, 0);
    var end = year + "-" + month + "-" + lastDateOfCurrentMonth.getDate();
    var obj = { begin: begin, end: end, month: month, lastMonth: lastMonth, lastbegin: lastbegin, lastend: lastend, year: year, last: last, lastyear: lastyear, date: date };
    return obj;
};

var generateId = exports.generateId = function generateId(length) {
    return (length || '') + new Date().getTime().toString(36) + Math.random().toString(36).slice(2);
};

var generateTreeStructure = exports.generateTreeStructure = function generateTreeStructure(data) {
    var cloneData = JSON.parse((0, _stringify2.default)(data));
    return cloneData.filter(function (father) {
        var branchArr = cloneData.filter(function (child) {
            return father.menu_id == child.menu_parent_id;
        });
        branchArr.length > 0 ? father.children = branchArr : '';
        return father.menu_parent_id == 0;
    });
};

var processRoutingStructure = exports.processRoutingStructure = function processRoutingStructure(data) {
    var newData = data.map(function (item) {
        if (item.children) {
            var menus = {
                id: item.menu_id,
                path: '/',
                component: (0, _menuList2.default)('/Home'),
                name: item.route.name,
                iconCls: item.iconCls,
                children: item.children.map(function (val) {
                    var childobj = {
                        id: val.menu_id,
                        path: val.route.path,
                        component: (0, _menuList2.default)(val.route.component),
                        name: val.route.name
                    };
                    return childobj;
                })
            };
            return menus;
        } else {
            var menu = {
                id: item.menu_id,
                path: '/',
                component: (0, _menuList2.default)('Home'),
                name: item.route.menu_name,
                iconCls: item.iconCls
            };
            return menu;
        }
    });
    return newData;
};

/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner.dadd7aa.jpeg";

/***/ }),

/***/ 257:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-pas"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.value
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "原密码："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "type": "password",
      "maxlength": 8,
      "show-word-limit": ""
    },
    model: {
      value: (_vm.value.user_name),
      callback: function($$v) {
        _vm.$set(_vm.value, "user_name", $$v)
      },
      expression: "value.user_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "新密码："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "type": "password",
      "maxlength": 8,
      "show-word-limit": ""
    },
    model: {
      value: (_vm.value.passwors),
      callback: function($$v) {
        _vm.$set(_vm.value, "passwors", $$v)
      },
      expression: "value.passwors"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "两次输入新密码："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "type": "password",
      "maxlength": 8,
      "show-word-limit": ""
    },
    model: {
      value: (_vm.value.newPasswors),
      callback: function($$v) {
        _vm.$set(_vm.value, "newPasswors", $$v)
      },
      expression: "value.newPasswors"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "btn-box"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("确定修改")])], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 258:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "box"
    }
  }, [_vm._m(0), _vm._v(" "), _c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2,
      "label-position": "left"
    }
  }, [_c('div', {
    staticClass: "login-container"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("龙杰一拍通登录")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "account"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "账号"
    },
    model: {
      value: (_vm.ruleForm2.account),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "account", $$v)
      },
      expression: "ruleForm2.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "密码",
      "maxlength": "8",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.ruleForm2.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "checkPass", $$v)
      },
      expression: "ruleForm2.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "verifyCode"
    }
  }, [_c('el-input', {
    staticClass: "inputGroup3",
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "prefix-icon": "login_yzm",
      "type": "text",
      "auto-complete": "off",
      "placeholder": "验证码"
    },
    model: {
      value: (_vm.ruleForm2.verifyCode),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "verifyCode", $$v)
      },
      expression: "ruleForm2.verifyCode"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "vcode",
    domProps: {
      "innerHTML": _vm._s(_vm.htmlscode)
    },
    on: {
      "click": _vm.switchVerificationCode
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%",
      "background": "#0066ff"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit2($event)
      }
    }
  }, [_vm._v("登   录")])], 1)], 1)]), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "banner"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(253),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dot"
  }, [_c('p', [_vm._v("\n      © 龙杰科技（深圳）有限公司.受法律保护\n      "), _c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn"
    }
  }, [_vm._v("粤ICP备16016531号")])])])
}]}

/***/ }),

/***/ 259:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("404 page not found")])
},staticRenderFns: []}

/***/ }),

/***/ 260:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 261:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "修改头像"
    }
  }, [_c('management')], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "密码设置"
    }
  }, [_c('password')], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 262:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-data"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.value
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "disabled": "",
      "maxlength": 8
    },
    model: {
      value: (_vm.value.user_name),
      callback: function($$v) {
        _vm.$set(_vm.value, "user_name", $$v)
      },
      expression: "value.user_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "头像："
    }
  }, [_c('div', {
    staticClass: "portrait-Img"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgUrl == '' ? _vm.deafult : _vm.imgUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "file-box"
  }, [_c('input', {
    staticClass: "file-updata",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.uploadPicture
    }
  })])])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 263:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "logo",
    class: _vm.collapsed ? 'logo-collapse-width' : 'logo-width',
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s(_vm.collapsed ? '' : _vm.sysName)), _c('span', [_vm._v("v.1.0.1")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('div', {
    staticClass: "tools",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.collapse($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  })])]), _vm._v(" "), _c('el-col', {
    staticClass: "breadcrumb-container",
    attrs: {
      "span": 5
    }
  }, [_c('el-breadcrumb', {
    staticClass: "breadcrumb-inner",
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.$route.matched), function(item) {
    return _c('el-breadcrumb-item', {
      key: item.path
    }, [_vm._v(_vm._s(item.name))])
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 3
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner "
  }, [_c('div', {
    staticClass: "imgBox"
  }, [_c('img', {
    attrs: {
      "src": this.sysUserAvatar
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "userBox"
  }, [_c('span', {
    staticClass: "username"
  }, [_vm._v(_vm._s(_vm.sysUserName))]), _vm._v(" "), _c('span', {
    staticClass: "RoleId"
  }, [_vm._v(_vm._s(_vm.adminRoleId))])])])]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', [_vm._v("我的消息")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.settings($event)
      }
    }
  }, [_vm._v("设置")]), _c('br'), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout($event)
      }
    }
  }, [_vm._v("退出登录")])], 1)], 1)], 1), _vm._v(" "), (_vm.$route.path == '/charts/echarts') ? _c('el-col', {
    staticClass: "sud",
    attrs: {
      "span": 5
    }
  }, [_vm._v("数据刷新: " + _vm._s(_vm.minutes) + " 分 " + _vm._s(_vm.seconds) + " 秒")]) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('aside', {
    class: _vm.collapsed ? 'menu-collapsed' : 'menu-expanded'
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.$route.path,
      "collapse": _vm.collapsed,
      "unique-opened": "",
      "router": "",
      "collapse-transition": false
    }
  }, [_vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? [(!item.leaf) ? _c('el-submenu', {
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('el-menu-item', {
        key: child.path,
        attrs: {
          "index": child.path
        }
      }, [_vm._v(_vm._s(child.name))]) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (item.leaf && item.children.length > 0) ? _c('el-menu-item', {
      attrs: {
        "index": item.children[0].path
      }
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(item.children[0].name))])]) : _vm._e()] : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./views/404.vue": [
		106
	],
	"./views/Home.vue": [
		107
	],
	"./views/Login.vue": [
		108
	],
	"./views/Main.vue": [
		268,
		16
	],
	"./views/Management/Management.vue": [
		269,
		10
	],
	"./views/Management/identity.vue": [
		270,
		9
	],
	"./views/Management/permissions.vue": [
		271,
		8
	],
	"./views/Management/role.vue": [
		272,
		7
	],
	"./views/charts/echarts.vue": [
		273,
		0
	],
	"./views/nav1/Form.vue": [
		274,
		6
	],
	"./views/nav1/Table.vue": [
		275,
		5
	],
	"./views/nav1/user.vue": [
		276,
		2
	],
	"./views/nav2/Page4.vue": [
		277,
		14
	],
	"./views/nav2/Page5.vue": [
		278,
		13
	],
	"./views/nav2/allRechargeRecords.vue": [
		279,
		4
	],
	"./views/nav2/export.vue": [
		280,
		1
	],
	"./views/nav2/failure.vue": [
		281,
		12
	],
	"./views/nav2/success.vue": [
		282,
		11
	],
	"./views/nav3/Userdata.vue": [
		283,
		3
	],
	"./views/nav3/checkPass.vue": [
		284,
		15
	],
	"./views/personalData/index.vue": [
		109
	],
	"./views/personalData/management/index.vue": [
		110
	],
	"./views/personalData/password/index.vue": [
		111
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 265;

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getorderStatus = undefined;

var _regenerator = __webpack_require__(178);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(176);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var getorderStatus = exports.getorderStatus = function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(params) {
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return _httpConfig2.default.get('/admin/index/orderStatus', params);

                    case 2:
                        return _context.abrupt('return', _context.sent);

                    case 3:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function getorderStatus(_x) {
        return _ref.apply(this, arguments);
    };
}();

exports.getCode = getCode;
exports.requestLogin = requestLogin;
exports.getUserData = getUserData;
exports.getUserDataDetails = getUserDataDetails;
exports.getOrder = getOrder;
exports.getIndex = getIndex;
exports.getorderMaxUser = getorderMaxUser;
exports.getorderReaderStatus = getorderReaderStatus;
exports.getorderTotal = getorderTotal;
exports.getorderLoadAmountMaxUser = getorderLoadAmountMaxUser;
exports.getorderMaxAmountStatus = getorderMaxAmountStatus;
exports.setadminpic = setadminpic;
exports.updatapwd = updatapwd;
exports.getReaderList = getReaderList;
exports.postDelete = postDelete;
exports.postStore = postStore;
exports.IdPostStore = IdPostStore;
exports.getAdminList = getAdminList;
exports.postAdaminAdd = postAdaminAdd;
exports.postAdminDelete = postAdminDelete;
exports.postAdminUpdate = postAdminUpdate;
exports.bannerList = bannerList;
exports.postBannerAdd = postBannerAdd;
exports.postBannerUpdatad = postBannerUpdatad;
exports.postBannerDelete = postBannerDelete;
exports.pictureClassification = pictureClassification;
exports.getlistClass = getlistClass;
exports.deletelistClass = deletelistClass;
exports.getListImages = getListImages;
exports.uploadImages = uploadImages;
exports.deleteImages = deleteImages;
exports.movingPictures = movingPictures;
exports.productCategories = productCategories;
exports.getGoodsActione = getGoodsActione;
exports.getGoodsId = getGoodsId;
exports.addProduct = addProduct;
exports.deleteProductCategories = deleteProductCategories;
exports.addCategoryList = addCategoryList;
exports.editCategoryList = editCategoryList;
exports.destoryCategoryList = destoryCategoryList;
exports.getMenuList = getMenuList;
exports.postMenuStore = postMenuStore;
exports.IdpostMenuStore = IdpostMenuStore;
exports.postMenuDelete = postMenuDelete;
exports.postRoleStore = postRoleStore;
exports.IdpostRoleStore = IdpostRoleStore;
exports.getRoleList = getRoleList;
exports.postRoleDelete = postRoleDelete;
exports.getRoleMenuList = getRoleMenuList;
exports.postRoleMenuStore = postRoleMenuStore;
exports.idPostRoleMenuStore = idPostRoleMenuStore;
exports.postRoleMenuDelete = postRoleMenuDelete;
exports.getOrderSearch = getOrderSearch;

var _httpConfig = __webpack_require__(67);

var _httpConfig2 = _interopRequireDefault(_httpConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getCode() {
    return _httpConfig2.default.post('/admin/auth/getCode');
}

function requestLogin(data) {
    return _httpConfig2.default.post('/admin/auth/login', data);
}
function getUserData(params) {
    console.log(params, "9999");
    return _httpConfig2.default.get('/admin/user', params);
}
function getUserDataDetails(params) {
    return _httpConfig2.default.get('admin/user/info?id=' + params);
}

function getOrder(params) {
    console.log(params);
    return _httpConfig2.default.get('admin/order', params);
}

function getIndex(params) {
    console.log(params);
    return _httpConfig2.default.get('admin/index', params);
}

function getorderMaxUser(params) {
    return _httpConfig2.default.get('/admin/index/orderMaxUser', params);
}

function getorderReaderStatus(params) {
    return _httpConfig2.default.get('/admin/index/orderReaderStatus', params);
}

function getorderTotal(params) {
    return _httpConfig2.default.get('/admin/index/orderTotal', params);
}

function getorderLoadAmountMaxUser(params) {
    return _httpConfig2.default.get('/admin/index/orderLoadAmountMaxUser', params);
}

function getorderMaxAmountStatus(params) {
    return _httpConfig2.default.get('admin/index/orderMaxAmountStatus', params);
}

function setadminpic(params) {
    return _httpConfig2.default.post('/admin/upload/setadminpic', params);
}
function updatapwd(params) {
    return _httpConfig2.default.post('/admin/admin/updatapwd', params);
}

function getReaderList(params) {
    return _httpConfig2.default.get('/admin/reader/list', params);
}

function postDelete(params) {
    return _httpConfig2.default.post('/admin/reader/delete', params);
}

function postStore(params) {
    return _httpConfig2.default.post('/admin/reader/store', params);
}
function IdPostStore(params) {
    return _httpConfig2.default.post('/admin/reader/store?id=' + params, params);
}

function getAdminList(params) {
    return _httpConfig2.default.get('/admin/admin/list', params);
}

function postAdaminAdd(params) {
    return _httpConfig2.default.post('/admin/admin/add', params);
}

function postAdminDelete(params) {
    return _httpConfig2.default.post('/admin/admin/delete', params);
}

function postAdminUpdate(params) {
    return _httpConfig2.default.post('/admin/admin/update', params);
}

function bannerList(params) {
    return _httpConfig2.default.get('/admin/banner/list', params);
}

function postBannerAdd(params) {
    return _httpConfig2.default.post('/admin/banner/add', params);
}

function postBannerUpdatad(params) {
    return _httpConfig2.default.post('/admin/banner/updatad', params);
}

function postBannerDelete(params) {
    return _httpConfig2.default.post('/admin/banner/delete', params);
}
function pictureClassification(params) {
    return _httpConfig2.default.post('/admin/imagecategory/store', params);
}
function getlistClass(params) {
    return _httpConfig2.default.get('/admin/imagecategory/list', params);
}

function deletelistClass(params) {
    return _httpConfig2.default.post('/admin/imagecategory/delete', params);
}

function getListImages(params) {
    return _httpConfig2.default.get('/admin/upload/list', params);
}

function uploadImages(params) {
    return _httpConfig2.default.post('/admin/upload/uploadpic', params);
}

function deleteImages(params) {
    return _httpConfig2.default.post('/admin/upload/delete', params);
}

function movingPictures(params) {
    return _httpConfig2.default.post('/admin/upload/uploadpic', params);
}

function productCategories(params) {
    return _httpConfig2.default.get('/admin/category', params);
}

function getGoodsActione(params) {
    return _httpConfig2.default.get('/admin/goods', params);
}

function getGoodsId(params) {
    return _httpConfig2.default.get('/admin/goods/info', params);
}

function addProduct(params) {
    return _httpConfig2.default.post('/admin/goods/store', params);
}

function deleteProductCategories(params) {
    return _httpConfig2.default.post('/admin/goods/destory', params);
}

function addCategoryList(params) {
    return _httpConfig2.default.post('/admin/category/store', params);
}

function editCategoryList(params) {
    return _httpConfig2.default.post('/admin/category/add', params);
}

function destoryCategoryList(params) {
    return _httpConfig2.default.post('/admin/category/destory', params);
}

function getMenuList(params) {
    return _httpConfig2.default.get('/admin/menu/list', params);
}

function postMenuStore(params) {
    return _httpConfig2.default.post('/admin/menu/store', params);
}

function IdpostMenuStore(params) {
    return _httpConfig2.default.post('/admin/menu/store?id=' + params, params);
}

function postMenuDelete(params) {
    return _httpConfig2.default.post('/admin/menu/delete', params);
}

function postRoleStore(params) {
    return _httpConfig2.default.post('/admin/role/store', params);
}

function IdpostRoleStore(params) {
    return _httpConfig2.default.post('/admin/role/store?id=' + params, params);
}

function getRoleList(params) {
    return _httpConfig2.default.get('/admin/role/list', params);
}

function postRoleDelete(params) {
    return _httpConfig2.default.post('/admin/role/delete', params);
}

function getRoleMenuList(params) {
    return _httpConfig2.default.get('/admin/role_menu/list', params);
}

function postRoleMenuStore(params) {
    return _httpConfig2.default.post('/admin/role_menu/store', params);
}

function idPostRoleMenuStore(params) {
    return _httpConfig2.default.post('/admin/role_menu/store?id=' + params, params);
}

function postRoleMenuDelete(params) {
    return _httpConfig2.default.post('/admin/role_menu/delete', params);
}

function getOrderSearch(params) {
    return _httpConfig2.default.get('/admin/order/orderSearch', params);
}

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(78);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(142);

var _axios2 = _interopRequireDefault(_axios);

var _index = __webpack_require__(68);

var _index2 = _interopRequireDefault(_index);

var _baseUrl = __webpack_require__(70);

var _baseUrl2 = _interopRequireDefault(_baseUrl);

var _elementUi = __webpack_require__(69);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var http = {};

var instance = _axios2.default.create({
    timeout: 5000,
    baseURL: _baseUrl2.default
});

instance.interceptors.request.use(function (config) {
    if (_index2.default.state.UserToken) {
        config.headers["x-nideshop-token"] = _index2.default.state.UserToken;
    }
    return config;
}, function (error) {
    return _promise2.default.reject(error);
});

instance.interceptors.response.use(function (response) {
    if (response.data.errno == 401) {
        console.log(_elementUi.MessageBox);
        _elementUi.MessageBox.alert('请重新登录', '提示', {
            confirmButtonText: '确定',
            callback: function callback(action) {
                sessionStorage.removeItem('user');
                window.location.reload();
            }
        });
    } else {
        return response.data;
    }
}, function (err) {
    console.log(err);
    if (err && err.response) {
        switch (err.response.status) {
            case 400:
                err.message = '请求出错';
                break;
            case 401:
                _elementUi.Message.warning({
                    message: '授权失败，请重新登录'
                });
                _index2.default.commit('LOGIN_OUT');
                setTimeout(function () {
                    window.location.reload();
                }, 1000);

                return;
            case 403:
                err.message = '拒绝访问';
                break;
            case 404:
                err.message = '请求错误,未找到该资源';
                break;
            case 500:
                err.message = '服务器端出错';
                break;
        }
    } else {
        err.message = '连接服务器失败';
    }
    _elementUi.Message.error({
        message: err.message
    });
    return _promise2.default.reject(err.response);
});

http.get = function (url, params, options) {
    return new _promise2.default(function (resolve, reject) {
        instance.get(url, params, options).then(function (response) {
            resolve(response);
        }).catch(function (e) {
            console.log(e);
        });
    });
};

http.post = function (url, data, options) {
    return new _promise2.default(function (resolve, reject) {
        instance.post(url, data, options).then(function (response) {
            resolve(response);
        }).catch(function (e) {
            console.log(e);
        });
    });
};

exports.default = http;

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(3);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(37);

var _vuex2 = _interopRequireDefault(_vuex);

var _state = __webpack_require__(170);

var _state2 = _interopRequireDefault(_state);

var _getters = __webpack_require__(168);

var _getters2 = _interopRequireDefault(_getters);

var _actions = __webpack_require__(167);

var _actions2 = _interopRequireDefault(_actions);

var _mutations = __webpack_require__(169);

var _mutations2 = _interopRequireDefault(_mutations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

exports.default = new _vuex2.default.Store({
    state: _state2.default,
    getters: _getters2.default,
    mutations: _mutations2.default,
    actions: _actions2.default
});

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var baseUrl = 'https://www.acspay.cn';

exports.default = baseUrl;

/***/ })

},[166]);


// WEBPACK FOOTER //
// static/js/app.b863890ed6b341d96809.js